// extracted by mini-css-extract-plugin
module.exports = {"rowHeader":"Table_rowHeader__I_8Et","row":"Table_row__H8plF"};